import { ITree } from "./ITree";
import { IColor } from "../../server/src/tree/mapper/IColor"
import { IOpMapParams } from "../../server/src/tree/mapper/op/IOpMapParams"
import { IOpEtap, IOpOperacja, IOpParent } from "../../server/src/tree/mapper/op/IOp"
import { IPrj } from "../prj/IPrj";
import { ILbl } from "../lbl/ILbl";

export class tree_api {

    public static del_tree:string = "/api/tree/del";
    public static import_from_kalk:string = "/api/tree/import_from_kalk";
    public static update:string = "/api/tree/update"
    public static fill_and_validate:string = "/api/tree/fill_and_validate";

    public static find_by_id:string = "/api/tree/find_by_id";
    public static find_by_prj_id:string = "/api/tree/find_by_prj_id";
    public static find_trees_short:string = "/api/tree/find_trees_short";
    public static assign_prj:string = "/api/tree/assign_prj";
    public static get_selected_wykrojnik_for_tree = "/api/tree/get_selected_wykrojnik_for_tree";
    public static copy_full_tree="/api/tree/copy_full_tree";

    public static update_tree_from_colors="/api/tree/update_tree_from_colors"
    public static map_colors_to_tree="/api/tree/map_colors_to_tree"
    public static map_tree_to_operacje="/api/tree/map_tree_to_operacje"
    public static map_operacje_to_tree="/api/tree/map_operacje_to_tree"
    public static ensure_tree_exists="/api/tree/ensure_tree_exists"
    public static get_kkt="/api/tree/get_kkt"
    
    
}

export interface ITreeSvc {

    //import_from_kalk(prj_id:any, kalk_id: any): Promise<ITree | undefined> 
    update(tree:ITree): Promise<ITree | undefined> 
    fill_and_validate(tree: ITree): Promise<ITree | undefined> 

    find_by_id(_id:any):Promise<ITree | undefined > ;
    //find_by_prj_id(prj_id:any):Promise<ITree | undefined> ;
    find_trees_short(params:any):Promise<ITree[] | undefined> ;
    copy_full_tree(tree:ITree):Promise<ITree|undefined>;
    update_tree_from_colors(lbl: ILbl):Promise<ITree|undefined> 

    map_colors_to_tree(colors:IColor[],map_params:IOpMapParams):Promise<ITree|undefined> 
    map_operacje_to_tree(operacje: IOpOperacja[], parent: IOpParent, idn: string, nr: number|undefined, x:number, y:number): Promise<ITree|undefined> 
    map_tree_to_operacje(tree: ITree, parent: IOpParent): Promise<IOpOperacja[]> 
    
    find_prj_by_id(_id:any):Promise<IPrj | undefined > ;
    get_kkt(colors:IColor[]):Promise<any[]> 
    

}